window.addEventListener('message', (event) => {
    if (event.origin !== "https://formbuilder.hulkapps.com") return;

    if (event.data.type === "HULK_FORM_LOADED") {
        const iframe = document.getElementById("frame_Txz_cb-C2AhG2lgCeL70AQ");
        
        const urlParams = new URLSearchParams(window.location.search);
        const paramsObj = Object.fromEntries(urlParams.entries());

        iframe.contentWindow.postMessage({
            type: "SET_PARAMS",
            data: paramsObj
        }, "https://formbuilder.hulkapps.com");
    }
});